'use strict';


/* ========================================================
 * 		jQuery
 *
 * If you need jQuery in a JS file add this to the top of that file:
 * 		var $ = require('jquery');
 * If some JS code MUST have jQuery globally accessible then
 * add the following line inside this file (index.js).
 * 		var $ = window.jQuery = require('jquery');
 ========================================================= */
var $ = window.jQuery = require('jquery');

/* ========================================================
 * 		Requires
 ========================================================= */

// Polyfills
require('./polyfills/requestAnimationFrame.js');

// Lib
require('./lib/a4jAjaxEvents.js');

require('./site/Analytics');


// Components
require('./lib/Forms.js').init();
require('./site/MobileMenu.js').init();
require('./site/Tabs.js').init();
require('./site/Gallery.js').init();

require('./site/LiveChat.js').init();

require('./site/Blog.js').init();
require('./site/Entry.js').init();
require('./site/SolarPages.js').init();
require('./site/HowToReadYourBill.js').init();

require('./site/ResponsiveTables.js').init();

require('./site/DetailSummary.js').init();
